// Controls
import { ShareMenuButton } from "../../shareMenuButton/ShareMenuButton";
// Styles
import { usePlanHeaderControlsStyles } from "./PlanHeaderControls.styles";
// Utilities
import * as React from "react";
/**
 * Plan header controls shown in a Teams tab
 */ export const TeamsTabPlanHeaderControls = ({ shareMenuButtonProps, headerOverflowMenu })=>{
    const classes = usePlanHeaderControlsStyles();
    return /*#__PURE__*/ React.createElement("div", {
        "data-testid": "teams-tab-plan-header-controls",
        className: classes.root
    }, /*#__PURE__*/ React.createElement(ShareMenuButton, shareMenuButtonProps), headerOverflowMenu);
};
